<div class="d-flex flex-column h-100">

  <div class="d-flex justify-content-end py-1">
    <button
      nbButton ghost status="primary"
      (click)="exportInvestment()"
      nbTooltip="{{ 'Export excel' | translate }}"
      nbTooltipPlacement="left"
      class="excel-button"
    >
      <fa-icon [icon]="['fal', 'file-arrow-down']" size="xl"></fa-icon>
    </button>
  </div>

  <div class="flex-grow-1 spreadsheet-container">
    <!-- SPREADSHEET -->
    @if (currentScenario) {
      <app-ag-grid-investment
        #grid
        [investmentsListForcedScenario]="currentScenario"
        [investmentsListColumns]="investmentsListColumns"
        [investmentsListFilter]="investmentsListFilter"
        [applyPeriod]="applyPeriod"
        [isFidjiAct]="isFidjiAct"
        [showAddButton]="showAddButton"
      ></app-ag-grid-investment>
    } @else {
      <app-ag-grid-investment
        #grid
        [showScenarii]="true"
        [investmentsListColumns]="investmentsListColumns"
        [investmentsListFilter]="investmentsListFilter"
        [applyPeriod]="applyPeriod"
        [showAddButton]="showAddButton"
      ></app-ag-grid-investment>
    }
  </div>

</div>
